import React, { useContext, useState } from 'react';
import { Button, ButtonGroup, Col, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from 'lodash';
import { ItemDropdownMenu, OrderDropdownMenu, Pager, SortHeader } from '.';
import { api, constants, dateHelpers, helpers, UserContext } from '../utils';
import { useNavigate } from 'react-router-dom';

export default function PackingInquiryInvoiceGrid(props) {
  const navigate = useNavigate();
  const { currentUser } = useContext(UserContext);
  const [working, setWorking] = useState();
  let alreadyDisplayed = [];

  function getExcel() {
    setWorking(true);
    props.exportXlsxCallback();
    setWorking(false);
  }

  function showTrackingInfo(invoiceNum) {
    api
      .fetch(`Reference/Track`, { invoiceNum: invoiceNum })
      .then(response => {
        if (response.data.success && response.data.url.length) {
          window.open(response.data.url);
        } else {
          toast.info("Only able to provide detailed tracking information for UPS Shipments")
        }
      })
      .catch(api.catchHandler);
  }

  return (
    <>
      <Row className="align-items-center mt-3 mb-2">
        <Col className="transparent-background">
          <Pager
            callBack={props.pagerCallback}
            sizeCallback={props.sizeCallback ? props.sizeCallback : null}
            pageNumber={props.pageNumber}
            pageSize={props.pageSize ? props.pageSize : null}
            totalPages={props.totalPages}
            downloading={working}
          />
        </Col>
        <Col className="transparent-background">
          {props.data && props.data.length
            ? (<ButtonGroup className="float-end">
              {props.exportXlsxCallback
                ? <Button
                    title="Download as .xlsx"
                    className="shredButtonExcel ms-2"
                    onClick={getExcel}
                    disabled={working}
                  >
                    <FontAwesomeIcon icon="file-excel" size="lg" />
                  </Button>
                : null
              }
              {props.exportPdfCallback
                ? (<Button
                  title="Download as .pdf"
                  className="shredButton"
                  onClick={props.exportPdfCallback}
                  disabled={working}
                >
                  <FontAwesomeIcon icon="file-pdf" size="lg" />
                </Button>)
                : null
              }
              </ButtonGroup>)
            : null
          }
        </Col>
      </Row>
      <Table size="sm" className="data-table">
        <thead className="table-header">
          <tr>
            <th style={{ width: "6%" }}>
              <SortHeader
                displayName="Invoice"
                field="sopnumbe"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "sopnumbe"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "6%" }}>
              <SortHeader
                displayName="Order"
                field="orignumb"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "orignumb"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "6%" }}>
              <SortHeader
                displayName="Customer"
                field="custnmbr"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "custnmbr"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "8%" }}>
              <SortHeader
                displayName="PO"
                field="cstponbr"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "cstponbr"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "8%" }}>
              <SortHeader
                displayName={<span>Ship<br />Date</span>}
                field="docdate"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "docdate"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "10%" }}>
              <SortHeader
                displayName="Ship To"
                field="stLabel"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "stLabel"}
                callback={props.sortCallback}
              />
            </th>
            {currentUser?.isAnyCustomerTypeRole
              ? null
              : <th>
                  <SortHeader
                    displayName="Item"
                    field="itemnmbr"
                    sortDirection={props.sortDirection}
                    sorted={props.sortField === "itemnmbr"}
                    callback={props.sortCallback}
                  />
                </th>
            }
            <th style={{ width: "14%" }}>
              Tracking #
            </th>
            <th style={{ width: "8%" }}>
              <SortHeader
                displayName={<span>Unit<br />Price</span>}
                field="unitprce"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "unitprce"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "8%" }}>
              <SortHeader
                displayName="Qty"
                field="quantityLabel"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "quantityLabel"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "10%" }}>
              <SortHeader
                displayName={<span>Ext<br />Price</span>}
                field="xtndprce"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "xtndprce"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "6%" }}>
              <SortHeader
                displayName="Balance"
                field="invoiceBalance"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "invoiceBalance"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "5%" }}>
              <SortHeader
                displayName="Paid Date"
                field="invoicePayOffDate"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "invoicePayOffDate"}
                callback={props.sortCallback}
              />
            </th>
            <th style={{ width: "2%" }}>
              <SortHeader
                displayName="Days"
                field="payDays"
                sortDirection={props.sortDirection}
                sorted={props.sortField === "payDays"}
                callback={props.sortCallback}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {_.map(props.data, (qr, ind) => {
            const displayed = _.includes(alreadyDisplayed, qr.orderId);
            alreadyDisplayed.push(qr.orderId);
            return (
              <tr key={ind} className={`tr-${ind % 2 === 0 ? "primary" : "secondary"}`}>
                {displayed ? <td className='data-cell'/> :
                <OrderDropdownMenu
                  invoiceNumber={qr.orderId}
                  orderId={qr.originalOrderId ? qr.originalOrderId : qr.orderId}
                  attachmentCount={qr.soAttachmentCount}
                  orderType={qr.orderType}
                  hideCoALateShip
                  customerId={qr.customerId}
                />}
                {displayed ? <td className='data-cell'/> : <td className="data-cell" children={qr.originalOrderId} />}
                {displayed ? <td className='data-cell'/> :
                  <td
                    className="data-cell"
                  >
                    <span
                      className="shredLink fw-bold"
                      onClick={() => navigate(constants.ENDPOINTS.customerDashboard, { state: { value: qr.customerId, label: qr.customerIdName } })}
                    >
                      {qr.customerId}
                    </span>
                  </td>
                }
                {displayed ? <td className='data-cell'/> : <td className="data-cell" children={qr.customerPONumber} />}
                {displayed ? <td className='data-cell'/> : <td className="data-cell" children={dateHelpers.toLongDateString(qr.documentDate)} />}
                {displayed ? <td className='data-cell'/> : <td className="data-cell" children={qr.stLabel} />}
                {currentUser?.isAnyCustomerTypeRole
                  ? null
                  : <ItemDropdownMenu
                      itemNumber={qr.itemNumber}
                      itemDescription={qr.itemWithDesc}
                      attachmentCount={qr.itemAttachmentCount}
                    />
                }
                {displayed ? <td className='data-cell'/> :
                  <td className="data-cell">
                    <span
                      children={qr.trackingNumber}
                      className="shredLink fw-bold cursor-pointer"
                      onClick={() => showTrackingInfo(qr.orderId)}
                    />
                  </td>}
                <td className="data-cell" children={helpers.formatCurrency(qr.unitPrice)} />
                <td className="data-cell" children={`${qr.qtytoinv.toLocaleString()} ${qr.unitOfMeasure}`} />
                <td className="data-cell" children={helpers.formatCurrency(qr.extendedPrice)} />
                {displayed ? <td className='data-cell'/> : <td className="data-cell" children={helpers.formatCurrency(qr.invoiceBalance)} />}
                {displayed ? <td className='data-cell'/> : <td className="data-cell" children={dateHelpers.toLongDateString(qr.invoicePayOffDate) === '01/01/1900' ? "" : dateHelpers.toLongDateString(qr.invoicePayOffDate)} />}
                {displayed ? <td className='data-cell'/> : <td className="data-cell" children={qr.payDays === 0 ? "" : qr.payDays} />}
              </tr>
            )
          })}
        </tbody>
        <tfoot className="table-footer">
          <tr>
            <td
              className="fw-bold"
              colSpan={currentUser?.isAnyCustomerTypeRole ? "8" : "9"}
              children="Totals Across All Pages:"
            />
            <td className="fw-bold" children={props.totals.quantityTotal.toLocaleString('en-US')} />
            <td className="fw-bold" children={helpers.formatCurrency(props.totals.extendedPriceTotal)} />
            <td className="fw-bold" children={helpers.formatCurrency(props.totals.balanceTotal)} />
            <td />
            <td className="fw-bold" children={props.totals.payDaysAverage} />
          </tr>
        </tfoot>
      </Table>
    </>
  )
}